import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['FiltersPopupStyles-cvaRoot', 'fixed left-0 top-0 z-[200]', 'w-full h-full']);

export const cvaOverlay = cva([
  'FiltersPopupStyles-cvaOverlay',
  'absolute left-0 top-0 ',
  'w-full h-full',
  'bg-cBlack32',
]);

export const cvaClose = cva([
  'FiltersPopupStyles-cvaClose',
  'flex items-center justify-center',
  'w-2.4 sm:w-5.6 h-2.4 sm:h-5.6',
  'sm:bg-cWhite',
  'rounded-[1.6rem]',
  'cursor-pointer select-none',
]);

export const cvaCloseWrapper = cva([
  'FiltersPopupStyles-cvaCloseWrapper',
  'absolute top-1.2 sm:top-4 right-2.4 sm:right-[46.7rem] z-[10]',
]);

export const cvaCloseIcon = cva([
  'ReviewPopupStyles-cvaCloseIcon',
  'hidden sm:block',
  'w-2.4 sm:w-1.6 h-1.6 sm:h-1.6',
  'fill-cBlack',
]);

export const cvaCloseIcon2 = cva([
  'FiltersPopupStyles-cvaCloseIcon2',
  'sm:hidden',
  'w-2.4 sm:w-1.6 h-2.4 sm:h-1.6',
  'fill-cBlack',
]);

export const cvaBack = cva([
  'FiltersPopupStyles-cvaBack',
  'absolute top-1.2 left-2.4 z-[2]',
  'sm:hidden',
  'w-2.4 sm:w-1.6 h-2.4 sm:h-1.6',
]);

export const cvaBackIcon = cva(['FiltersPopupStyles-cvaBackIcon', 'w-2.4 sm:w-1.6 h-2.4 sm:h-1.6', 'fill-cBlack']);

export const cvaInner = cva([
  'FiltersPopupStyles-cvaInner',
  'absolute right-0 top-0 overflow-hidden',
  'h-full w-full sm:w-[43.5rem]',
  'bg-cWhite',
  'sm:rounded-tl-[3.2rem] sm:rounded-bl-[3.2rem]',
]);

export const cvaForm = cva(['FiltersPopupStyles-cvaForm', 'h-full']);

export const cvaHeader = cva([
  'FiltersPopupStyles-cvaHeader',
  'sm:hidden',
  'py-1.4 px-2.4 sm:p-0',
  'bg-cLightGrey sm:bg-transparent',
]);

export const cvaHeaderTitle = cva([
  'FiltersPopupStyles-cvaHeaderTitle',
  'sm:hidden',
  'text-labelL uppercase text-center',
]);

export const cvaTitle = cva(['FiltersPopupStyles-cvaTitle', 'hidden sm:block', 'mb-2.4', 'text-h3 font-secondary']);

export const cvaGroup = cva(['FiltersPopupStyles-cvaGroup', 'not-last:mb-1.6 sm:not-last:mb-2.4']);

export const cvaScroll = cva([
  'FiltersPopupStyles-cvaScroll',
  'overflow-y-auto',
  'h-full',
  'py-3.2 sm:py-4.8 px-2.4 sm:px-5.6 pb-[15rem] sm:pb-[20rem]',
]);

export const cvaFooter = cva([
  'FiltersPopupStyles-cvaFooter',
  'absolute bottom-0 left-0 z-[2]',
  'w-full',
  'py-1.6 px-2.4 sm:px-5.6',
  'bg-cWhite',
  'rounded-[3.2rem] rounded-br-none',
  '[box-shadow:0_0_5.6rem_0_rgba(33,_61,_56,_0.12)]',
]);

export const cvaApplyButton = cva([
  'FiltersPopupStyles-cvaApplyButton',
  'w-full',
  'mb-0.8',
  'py-1.3 sm:py-1.4 pb-1.6 sm:pb-1.8',
  'text-bodyM',
  'w-full',
]);

export const cvaResetButton = cva([
  'FiltersPopupStyles-cvaResetButton',
  'w-full',
  'py-1.3 sm:py-1.4 pb-1.6 sm:pb-1.8',
  'text-bodyM',
]);
